import { motion } from 'framer-motion';
import { Button } from '~/shared/ui/Button/Button';
import {
  cvaPayment,
  cvaPaymentBlock,
  cvaPaymentForm,
  cvaPaymentFormTitle,
  cvaPaymentInfo,
  cvaPaymentInfoDescription,
} from '~/widgets/Payment/ui/PaymentStyles';
import { PaymentBox } from '~/widgets/Payment/ui/PaymentBox/PaymentBox';
// import { CarNumber } from '~/widgets/Payment/ui/CarNumber/CarNumber';
import { FC, useEffect, useState } from 'react';
// import { PaymentTitleBlock } from '~/widgets/Payment/ui/PaymentTitleBlock/PaymentTitleBlock';
// import { usePaymentData } from '~/shared/hooks/usePaymentData';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ControlledCheckbox } from '~/widgets/Payment/ui/ControlledCheckbox/ControlledCheckbox';
// import { CardSwitch } from '~/widgets/Payment/ui/CardSwitch/CardSwitch';
import { BackLink } from '~/entities/BackLink/BackLink';
import { OwnBlock } from '~/shared/ui/OwnBlock/OwnBlock';
import { CardSwitcher } from '~/widgets/CardSwitcher/CardSwitcher';
import { CarNumberExample } from '~/shared/ui/CarNumberExample/CarNumberExample';
import {
  cvaRadioGroupBox,
  cvaRadioGroupItemWrapper,
  cvaRadioGroupItem,
  cvaRadioGroupCardInfo,
} from '~/shared/ui/RadioGroup/RadioGroupStyles';
import { ActiveRent } from '~/shared/API/response-types/rent-types';
import { priceFormatter } from '~/shared/utils/priceFormatter';
import { usePayRentSession } from '~/shared/hooks/usePaySession';
import { useGetCards } from '~/shared/hooks/useGetCards';
// import { PaymentWidget } from './PaymentWidget/PaymentWidget';
import { Portal } from '~/shared/ui/Portal/Portal';
import {
  cvaAddParkingPageTitle,
  cvaAddParkingPageLabel,
} from '~/pages/AddParkingPage/ui/AddParkingPageStyles';
import {
  cvaAddParkingPageWrap,
  cvaAddParkingPageImage,
  cvaAddParkingPageGradient,
  cvaAddParkingPageIcon,
  cvaAddParkingPageButtons,
} from '~/pages/AddParkingSuccess/ui/AddParkingSuccessStyles';
import { Popup } from '~/entities/Popup/Popup';

interface Props {
  onClose: () => void;
  onPay: () => void;
  rent: ActiveRent;
  title: string;
  hourly?: boolean;
}

export interface Form {
  autoRenewal: boolean;
  carNumber: string;
}

export const Payment: FC<Props> = ({ onClose, hourly, rent }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState<null | string>(null);

  const { cards, isLoading: loadingCards } = useGetCards();

  const { data, pay, isLoading, isError: isErrorPay } = usePayRentSession();

  const { handleSubmit, control, watch } = useForm<Form>();
  const onSubmit: SubmitHandler<Form> = async () => {
    const card = cards.find((card) => card.is_default);
    card
      ? pay({ sessionId: rent.id, cardId: card.id })
      : pay({ sessionId: rent.id });
  };

  const autoRenewal = watch('autoRenewal');

  useEffect(() => {
    if (data?.paymentWindow && isErrorPay) {
      data?.paymentWindow.close();
      setIsError('Попробуйте еще раз');
    }
  }, [isErrorPay]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.includes('closeIframe')) {
        if (event.data.includes('error')) {
          setIsError(event.data.replace('closeIframe, error:', ''));
        } else setIsSuccess(true);
        if (data?.paymentWindow) data?.paymentWindow.close();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ ease: 'easeOut', duration: 0.2 }}
        className={cvaPayment()}>
        <BackLink
          text={
            rent.status !== 'completed'
              ? 'Оплата парковки'
              : 'Парковочная сессия'
          }
          href={''}
          onClick={onClose}
          navigation={false}
        />
        {!isSuccess ? (
          <form className={cvaPaymentForm()} onSubmit={handleSubmit(onSubmit)}>
            {rent.status !== 'completed' ? (
              <PaymentBox variant={'nonR'}>
                {/* <CardSwitch /> */}

                <div className={'mr-1.6'}>
                  <Button
                    //  onClick={onPay}
                    isLoading={isLoading || loadingCards}
                    type={'submit'}
                    variant={'primary'}
                    size={'common'}
                    className={'w-full'}>
                    Оплатить {priceFormatter(rent.receipt.total)}
                  </Button>
                </div>

                {autoRenewal && (
                  <span className={cvaPaymentInfoDescription()}>
                    оплата будет списываться каждый день, пока вы или
                    собственник не&nbsp;отмените аренду
                  </span>
                )}
              </PaymentBox>
            ) : (
              <div className="h-10" />
            )}
            <OwnBlock className={cvaPaymentBlock()}>
              <div>
                <p className={cvaPaymentFormTitle()}>
                  {rent.parking_space.parking?.name}
                </p>
                <span>{rent.parking_space.parking.address}</span>{' '}
              </div>
            </OwnBlock>
            {/* {paymentInfo?.data && (
              <OwnBlock className={cvaPaymentBlock()}>
                Статус оплаты - {paymentInfo?.data?.status}
              </OwnBlock>
            )} */}
            <OwnBlock className={cvaPaymentBlock()}>
              <p className={cvaPaymentFormTitle()}>Аренда</p>
              <div>
                {/* <div className={cvaPaymentInfo()}>
              <span>Срок</span> <p>3 часа 30 минут</p>
            </div>

            <div className={cvaPaymentInfo()}>
              <span>Дата аренды</span> <p></p>
            </div> */}

                <div className={cvaPaymentInfo()}>
                  <span>Условия</span>{' '}
                  <p>
                    Первые {rent.receipt.rate.free_period_minutes} мин -
                    бесплатно <br /> Почасовая ставка -{' '}
                    {priceFormatter(rent.receipt.rate.hourly_price)}/час
                  </p>
                  <p></p>
                </div>
                {rent.receipt.items?.length
                  ? rent.receipt.items.map((item, index) => (
                      <div className={cvaPaymentInfo()} key={index}>
                        <span>{item.name.replace('парковочного', '')}</span>{' '}
                        <p>
                          {item.description}, {priceFormatter(item.amount)}
                        </p>
                      </div>
                    ))
                  : null}
                <div className={cvaPaymentInfo()}>
                  <span>Итого</span>{' '}
                  <p>
                    <span>{priceFormatter(rent.receipt.total)}</span>
                  </p>
                </div>
              </div>
            </OwnBlock>
            <OwnBlock className={cvaPaymentBlock()}>
              <p className={cvaPaymentFormTitle()}>Автомобиль</p>
              <div
                className={cvaRadioGroupBox({ bg: 'gray', type: 'secondary' })}>
                <div className={cvaRadioGroupItemWrapper()}>
                  <div
                    className={cvaRadioGroupItem({
                      type: 'secondary',
                      cars: true,
                    })}>
                    <div className={cvaRadioGroupCardInfo({ cars: true })}>
                      <div>
                        {rent.auto.name}
                        {<CarNumberExample text={rent.auto.number} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </OwnBlock>
            {!hourly && <ControlledCheckbox control={control} />}
            {rent.status !== 'completed' && (
              <OwnBlock className={cvaPaymentBlock()}>
                <p className={cvaPaymentFormTitle()}>Способ оплаты</p>
                <CardSwitcher variant={'default'} text={'Добавить карту'} />
              </OwnBlock>
            )}
            {rent.status !== 'completed' && <div className="h-[22.4rem]" />}
          </form>
        ) : (
          <div className={cvaAddParkingPageWrap()}>
            <div className={cvaAddParkingPageImage()}>
              <img
                src="/images/gradient.png"
                alt=""
                className={cvaAddParkingPageGradient()}
              />
              <img
                src="/images/plane-check.png"
                alt=""
                className={cvaAddParkingPageIcon()}
              />
            </div>
            <p className={cvaAddParkingPageTitle()}>Оплата прошла успешно</p>
            <p className={cvaAddParkingPageLabel()}>Чек отправили в СМС</p>
            <div className={cvaAddParkingPageButtons()}>
              <Button
                size={'common'}
                variant={'primary'}
                onClick={() => onClose()}>
                На главную
              </Button>
            </div>
          </div>
        )}
      </motion.div>{' '}
      {isError && isError?.length ? (
        <Portal>
          <Popup
            formPopup
            title="Ошибка оплаты"
            image="/images/card-error.png"
            description={isError}
            button={{
              text: 'Повторить',
              isLoading: isLoading,
              action: () => {
                pay({ sessionId: rent.id });
                setIsError('');
              },
            }}
            button_second={{ text: 'Закрыть', action: () => setIsError('') }}
            open
          />
        </Portal>
      ) : null}
      {/* {openPaymentWidget && url?.length ? (
        <Portal>
          <PaymentWidget
            title="Оплата парковки"
            url={url}
            setIsError={(message) => setIsError(message)}
            setIsSuccess={() => setIsSuccess(true)}
            onClose={() => setOpenPaymentWidget(false)}
          />
        </Portal>
      ) : null} */}
    </>
  );
};
